import { AuthenticationContext, withAdalLogin } from 'react-adal';

export const adalConfig = {
    // tenant: "common",
    clientId: "a6a6eec7-4bcd-405a-9714-2cc48651ed86",
    // endpoints: {
    //     api: "DOHERTYASSOCIATES.onmicrosoft.com/a6a6eec7-4bcd-405a-9714-2cc48651ed86"
    // },
    cacheLocation: 'localStorage',
    postLogoutRedirectUri: window.location.origin,
};

export const authContext = new AuthenticationContext(adalConfig);

export const getToken = () => {
    return new Promise((resolve, reject) => {
        authContext.acquireToken(authContext.config.clientId, (err, token) => {
            if (!err) {
                resolve(`Bearer ${token}`);
            } else {
                authContext.acquireTokenPopup(authContext.config.clientId, null, null, (token, err) => {
                    if (!err) {
                        resolve(`Bearer ${token}`)
                    } else {
                        logout();
                    }
                })
            }
        })
    })
}

export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.clientId);

export const logout = () => {
    sessionStorage.clear();
    localStorage.clear();
    return authContext.logOut();
}


// WEBPACK FOOTER //
// ./src/adal/adalConfig.js